import { rawDigits, localTodayISO } from './intakeConstants';

/** Returns an `errors` object for the given step. Empty when valid. */
export function validateStep(step, formData) {
  const e = {};

  if (step === 1 && !formData.company) {
    e.company = 'Company Required!';
  }

  if (step === 2) {
    if (!formData.dateOfLoss) {
      e.dateOfLoss = 'Date Of Loss is required';
    } else if (formData.dateOfLoss > localTodayISO()) {
      e.dateOfLoss = 'Date Of Loss cannot be in the future';
    }
  }

  if (step === 3) {
    if (formData.lossTypes.length === 0) e.lossTypes = 'Select at least one type of loss';
    if (!formData.faultOfDriver) e.faultOfDriver = 'Fault Of Driver selection is required';
  }

  if (step === 4) {
    if (!formData.driverName.trim()) e.driverName = 'Driver name is required';
    if (formData.driverPhone && rawDigits(formData.driverPhone).length !== 10) {
      e.driverPhone = 'Phone must be 10 digits';
    }
  }

  if (step === 5) {
    if (!formData.truckNumber.trim()) e.truckNumber = 'Truck # is required';
  }

  if (step === 6) {
    if (!formData.location.trim()) e.location = 'Location is required';
    if (!formData.lossDescription.trim()) e.lossDescription = 'Loss description is required';
    if (!formData.policeInvolved) e.policeInvolved = 'Police Involved selection is required';
    if (formData.policeInvolved === 'Yes') {
      if (!formData.citationIssued) e.citationIssued = 'Citation Issued selection is required';
      if (!formData.policeReportNotReady && !formData.policeReportNo.trim()) {
        e.policeReportNo = 'Police Report # is required';
      }
    }
    if (!formData.otherVehicle) e.otherVehicle = 'Other Vehicle Involved selection is required';
  }

  if (step === 7) {
    if (formData.uploadedFiles.length === 0) e.uploadedFiles = 'Please upload at least one file';
    if (formData.selectedDocuments.length === 0) e.selectedDocuments = 'Please select at least one document type';
  }

  return e;
}
